import { createFileRoute } from '@tanstack/react-router';

import { getJournalOptions } from '@/module/Journal';

export const Route = createFileRoute('/_auth/journal/_journal/$journalId/_layout')({
  loader: async ({ params: { journalId }, context: { queryClient } }) => {
    const journal = await queryClient.ensureQueryData(getJournalOptions(journalId));

    return {
      journal,
      crumb: journal.title,
    };
  },
});
